import { graphql } from 'gatsby';
import { useState } from 'react';
import classNames from 'classnames';
import copy from 'copy-text-to-clipboard';
import { Icon, Form, Overlay, Tooltip } from '@ahaui/react';
import { icons } from '@ahaui/react/constants/icons';
import ComponentApi from 'src/components/ComponentApi';
import CodeView from 'src/components/CodeView';
import colorIcon from 'src/examples/Icon/color';
import sizeIcon from 'src/examples/Icon/size';
import * as React from 'react';
export default {
  graphql,
  useState,
  classNames,
  copy,
  Icon,
  Form,
  Overlay,
  Tooltip,
  icons,
  ComponentApi,
  CodeView,
  colorIcon,
  sizeIcon,
  React
};